import { render, staticRenderFns } from "./nutritionalGoals.vue?vue&type=template&id=99690e58&scoped=true&"
import script from "./nutritionalGoals.vue?vue&type=script&lang=js&"
export * from "./nutritionalGoals.vue?vue&type=script&lang=js&"
import style0 from "./nutritionalGoals.vue?vue&type=style&index=0&id=99690e58&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99690e58",
  null
  
)

component.options.__file = "nutritionalGoals.vue"
export default component.exports